import { useStoreState } from '@src/model/hooks';
import type { ContentEntityType } from '@src/store/contentEntities/model';
import { type Reaction, reactionAtomFamily } from '@src/store/reactions/reactions';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { generateReactionId } from '../helpers/reactions';

export interface UseMyReactionPayload {
    entityId: string;
    entityType: ContentEntityType;
}

export interface UseMyReaction {
    myReaction: Reaction | undefined;
    myReactionName: string;
}

function useMyReaction(payload: UseMyReactionPayload): UseMyReaction {
    const { entityId, entityType } = payload;

    const myUserId = useStoreState(state => state.user.myUserId);

    const reactionId = useMemo(() => {
        if (!myUserId) return;
        return generateReactionId(myUserId, entityType, entityId);
    }, [myUserId, entityId, entityType]);

    const myReaction = useAtomValue(reactionAtomFamily(reactionId));

    return { myReaction, myReactionName: myReaction?.reactionName || '' };
}

export default useMyReaction;
